<div class="header">
  <div>
    <h2>User KPS List</h2>
    <p>
      Track, manage, and monitor points efficiently to keep everything
      organized.
    </p>
  </div>
  <button class="add-btn" (click)="toggleModal()">
    <img src="assets/images/PlusIcon.svg" alt="" />
    Add New KPS
  </button>
</div>

<div class="rp-body">
  <div class="table-wrapper">
    <table>
      <thead>
        <tr>
          <th>Title</th>
          <th>Value</th>
          <th>Type</th>
          <th class="text-right pr-4">Action</th>
        </tr>
      </thead>

      <tbody *ngIf="loading || showSkeleton">
        <tr *ngFor="let row of skeletonRows">
          <td *ngFor="let col of skeletonCols">
            <div class="skeleton-cell"></div>
          </td>
        </tr>
      </tbody>

      <!-- REAL DATA BODY -->
      <tbody *ngIf="!loading && !showSkeleton">
        @for (item of userKps; track item.title; let i = $index) {
        <tr>
          <td>{{ item.title }}</td>
          <td>{{ item.value }}</td>
          <td>{{ item.type }}</td>
          <td class="text-right icon-btns">
            <button class="btn-icon" (click)="openEditModal(item, i)">
              <img src="assets/images/editIcon.svg" alt="Edit" />
            </button>
            <!-- <button class="btn-icon" (click)="deleteItem(i)"> -->
            <button class="btn-icon" (click)="openDeleteModal(item.id)">
              <img src="assets/images/trashIcon.svg" alt="Delete" />
            </button>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>
</div>
<app-add-popup *ngIf="showModal" [title]="isEditMode ? 'Edit KPS' : 'Add New KPS'" [subtitle]="
    isEditMode
      ? 'Update KPS details to modify this record'
      : 'Create new KPS to track and evaluate performance effectively.'
  " [iconPath]="
    isEditMode ? 'assets/images/editPopup.png' : 'assets/images/addPopup.png'
  " (close)="toggleModal()">
  <form [formGroup]="kpsForm" (ngSubmit)="onSave()">
    <div class="input-group">
      <label>Title*</label>
      <input type="text" formControlName="title" placeholder="Write here" />
    </div>
    <div class="row-group">
      <div class="input-group value-group">
        <label>KPS Value*</label>
        <div class="percent-input">
          <input type="number" formControlName="value" placeholder="Write here" min="0" max="100" />
          <span class="suffix">%</span>
        </div>
      </div>
      <div class="input-group">
        <label>Designation</label>
        <div class="select-wrapper">
          <select formControlName="type">
            <option value="null" disabled selected hidden>Choose from here</option>
            @for (role of office_roles_array; track role) {
            <option [value]="role.role_names">{{ role.role_names }}
            </option>
            }
          </select>
          <span class="arrow">
            <img src="assets/images/chevron-down.svg" />
          </span>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn-cancel" (click)="toggleModal()">

        Cancel
      </button>
      <button type="submit" class="btn-save" [disabled]="kpsForm.invalid">
        <span><img src="assets/images/savePopup.svg" /></span>
        Save
      </button>
    </div>
  </form>
</app-add-popup>
<app-add-popup *ngIf="showDeleteModal" title="Delete KPS"
  subtitle="Are you sure you want to delete this KPS record? This action cannot be undone."
  iconPath="assets/images/deleteicon.svg" (close)="closeDeleteModal()">
  <div class="modal-footer justify-center">
    <button type="button" class="btn-cancel" (click)="closeDeleteModal()">
      Cancel
    </button>
    <button type="button" class="btn-save" (click)="confirmDelete()">
      <span> <fa-icon [icon]="faTrashCan"></fa-icon></span> Delete
    </button>
  </div>
</app-add-popup>